import React, { ReactElement } from 'react';
import AppLogoBrand from './AppLogoBrand';

interface Props {
    height?: number;
    width?: number;
    useExtended?: boolean;
}

function AppLogoBrandSafespring({
    height = 28,
    width = 90,
    useExtended = true,
}: Props): ReactElement {
    return (
        <AppLogoBrand
            height={height}
            logo={
                useExtended
                    ? 'provider-safespring-brand-logo'
                    : 'provider-safespring-brand-logo-short'
            }
            size=""
            testId="AppLogoBrandSafespring"
            width={width}
        />
    );
}

export default AppLogoBrandSafespring;
